class Store {
    getData() {
        return this.data
    }
    setData(data){
        data && (this.data = data)
    }
}

const store = new Store()

export { store }